import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { H2, Loader, ReferenceField } from '~/components';
import { Section } from '~/layout';
import { useGetTransaction } from '~/hooks/headTransactions';
import TrxDetailsTab from '~/resources/headTransactions/components/DetailsTab';
import { ApprovalCaseDetail } from '~/types/approvalCase';
import { useTranslate } from 'react-admin';

interface Props {
  record: ApprovalCaseDetail;
}

const TransactionApprovalDetailsTab: FC<Props> = ({ record }) => {
  const { objectId, objectType } = record;
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string) => translate(`resources.approvals.show.data.${key}`);
  const { data: transaction, isLoading } = useGetTransaction(objectId, { staleTime: Infinity });

  if (isLoading) return <Loader />;

  return (
    <>
      <H2 topSpacing={0} bottomSpacing={2}>
        {t('objectDetails')}
      </H2>
      <Section>
        <Grid container spacing={2} className={classes.bottomSpacing}>
          <Grid item xs={4}>
            <ReferenceField record={{ id: objectId, type: objectType }} />
          </Grid>
        </Grid>
      </Section>
      <TrxDetailsTab record={transaction} readOnly />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    paddingBottom: theme.spacing(3),
  },
}));

export default TransactionApprovalDetailsTab;
